import { render } from "./ManageTargetGroupsModal.vue?vue&type=template&id=90e7a230"
import script from "./ManageTargetGroupsModal.vue?vue&type=script&lang=js"
export * from "./ManageTargetGroupsModal.vue?vue&type=script&lang=js"

import "./ManageTargetGroupsModal.vue?vue&type=style&index=0&id=90e7a230&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__